import * as types from "../../actionType";

const initialState = {
  saveCloseToggle: false,
  getSrDataList: [],
  massSrSearchFilterResult: [],
  unsolicitedMassSearchFilterResult: [],
  seasonSearchFilterResult: [],
  brandComment: "",
  statusSavedData: "",
  exFactoryDateVar: "",
  reqRecDateVar: "",
  srSaveAllData: {},
  searchLoader: false,
  brandCommentLoader: false,
  brandStatusSaverLoader: false,
  designStatusSaverLoader: false,
  statusSaverLoader: false,
  srrandNames: "",
  SrSeaonsNames: "",
  srRowIndex: 0,
  srExportData: [],
  srExportArrayData: [],
  srSelectedTableRows: [],
  ReportGeneration: [],
  srRefreshSpinner: false,
  srCommentUpdate: {},
  srSearchData: [],
  srSeasonSearch: [],
  srBulkSaveResponse: {},
  srUnsolicitedList: [],
  srUnsolicitedExportData: [],
  srUnsolicitedBulkUpload: [],
  srUnsolicitedEdits: [],
  srLogsData: [],
  UnsolicitedList: [],
  clearData: {
    startDate: null,
    endDate: null,
  },
  loading: true,
};
export const srReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SAVE_CLOSE_TOGGLE:
      return {
        ...state,
        saveCloseToggle: action.payload,
        loading: false,
      };
    case types.CLEAR_DATE_ON_BTN_CLICK:
      return {
        ...state,
        clearData: action.payload,
        loading: false,
      };
    case types.RESET_SEASON_FILTER:
      return {
        ...state,
        seasonSearchFilterResult: action.payload,
        loading: false,
      };
    case types.RESET_SR_SEASON_FILTER:
      return {
        ...state,
        srSeasonSearch: action.payload,
        loading: true,
      };
    case types.RESET_SR_DATA:
      return {
        ...state,
        getSrDataList: action.payload,
        loading: false,
      };
    case types.RESET_SR_MASS_FILTER:
      return {
        ...state,
        massSrSearchFilterResult: action.payload,
        loading: true,
      };
    case types.RESET_MASS_UNSOLICITED_FILTER:
      return {
        ...state,
        unsolicitedMassSrSearchFilterResult: action.payload,
        loading: false,
      };
    case types.EXFACTORY_DATE:
      return {
        ...state,
        exFactoryDateVar: action.payload,
        loading: false,
      };
    case types.REQ_REC_DATE:
      return {
        ...state,
        reqRecDateVar: action.payload,
        loading: false,
      };
    case types.SR_BRANDS:
      return {
        ...state,
        srBrandName: action.payload,
        loading: false,
      };
    case types.SR_SEASONS:
      return {
        ...state,
        SrSeaonsName: action.payload,
        loading: false,
      };
    case types.ROW_INDEX_FOR_AUTOSCROLL:
      return {
        ...state,
        srRowIndex: action.payload,
        loading: false,
      };
    case types.SELECT_UNSELECT_SR_TABLE_ROWS:
      return {
        ...state,
        srSelectedTableRows: action.payload,
        loading: false,
      };
    case types.GET_SR_LIST_LOADING:
      return {
        ...state,
        loading: true,
        searchLoader: true,
        srRefreshSpinner: true,
      };
    case types.GET_SR_LIST_SUCCESS:
      return {
        ...state,
        getSrDataList: action.payload,
        loading: false,
        searchLoader: false,
        srRefreshSpinner: false,
      };
    case types.GET_SR_LIST_FAIL:
      return {
        ...state,
        loading: false,
        getSrDataList: [],
        searchLoader: false,
        srRefreshSpinner: false,
      };
    case types.MASS_SR_SEARCH_FILTER_LOADING:
      return {
        ...state,
        loading: true,
        searchLoader: true,
      };
    case types.MASS_SR_SEARCH_FILTER_SUCCESS:
      return {
        ...state,
        massSrSearchFilterResult: action.payload,
        loading: false,
        searchLoader: false,
      };
    case types.MASS_SR_SEARCH_FILTER_FAIL:
      return {
        ...state,
        loading: false,
        massSrSearchFilterResult: [],
        searchLoader: false,
      };
    case types.UNSOLICITED_MASS_SEARCH_FILTER_LOADING:
      return {
        ...state,
        loading: true,
        searchLoader: true,
      };
    case types.UNSOLICITED_MASS_SEARCH_FILTER_SUCCESS:
      return {
        ...state,
        unsolicitedMassSrSearchFilterResult: action.payload,
        loading: false,
        searchLoader: false,
      };
    case types.UNSOLICITED_MASS_SEARCH_FILTER_FAIL:
      return {
        ...state,
        loading: false,
        unsolicitedMassSrSearchFilterResult: [],
        searchLoader: false,
      };
    case types.SEASON_SEARCH_FILTER_LOADING:
      return {
        ...state,
        loading: true,
        searchLoader: true,
      };
    case types.SEASON_SEARCH_FILTER_SUCCESS:
      return {
        ...state,
        seasonSearchFilterResult: action.payload,
        loading: false,
        searchLoader: false,
      };
    case types.SEASON_SEARCH_FILTER_FAIL:
      return {
        ...state,
        loading: false,
        seasonSearchFilterResult: [],
        searchLoader: false,
      };
    case types.BRAND_COMMENT_SAVER_LOADING:
      return {
        ...state,
        loading: true,
        brandCommentLoader: true,
      };
    case types.BRAND_COMMENT_SAVER_SUCCESS:
      return {
        ...state,
        brandComment: action.payload,
        loading: false,
        brandCommentLoader: false,
      };
    case types.BRAND_COMMENT_SAVER_FAIL:
      return {
        ...state,
        loading: false,
        brandCommentLoader: false,
        brandComment: [],
      };

    case types.BRAND_STATUS_SAVER_LOADING:
      return {
        ...state,
        loading: true,
        brandStatusSaverLoader: true,
      };
    case types.BRAND_STATUS_SAVER_SUCCESS:
      return {
        ...state,
        statusSavedData: action.payload,
        loading: false,
        brandStatusSaverLoader: false,
      };
    case types.BRAND_STATUS_SAVER_FAIL:
      return {
        ...state,
        loading: false,
        brandStatusSaverLoader: false,
        statusSavedData: [],
      };

    case types.DESIGN_STATUS_SAVER_LOADING:
      return {
        ...state,
        loading: true,
        designStatusSaverLoader: true,
      };
    case types.DESIGN_STATUS_SAVER_SUCCESS:
      return {
        ...state,
        statusSavedData: action.payload,
        loading: false,
        designStatusSaverLoader: false,
      };
    case types.DESIGN_STATUS_SAVER_FAIL:
      return {
        ...state,
        loading: false,
        statusSavedData: [],
        designStatusSaverLoader: false,
      };

    case types.SR_DATA_SAVE_LOADING:
      return {
        ...state,
        loading: true,
        statusSaverLoader: true,
      };
    case types.SR_DATA_SAVE_SUCCESS:
      return {
        ...state,
        srSaveAllData: action.payload,
        loading: false,
        statusSaverLoader: false,
      };
    case types.SR_DATA_SAVE_FAIL:
      return {
        ...state,
        loading: false,
        statusSaverLoader: false,
        srSaveAllData: [],
      };
    case types.SR_EXPORT_LOADING:
      return {
        ...state,
        loading: true,
        searchLoader: true,
      };
    case types.SR_EXPORT_SUCCESS:
      return {
        ...state,
        srExportData: action.payload,
        loading: false,
        searchLoader: false,
      };
    case types.SR_EXPORT_FAIL:
      return {
        ...state,
        loading: false,
        srExportData: [],
        searchLoader: false,
      };
    case types.SR_EXPORT_DATA:
      return {
        ...state,
        srExportArrayData: action.payload,
        loading: false,
      };
    case types.SR_REPORT_GENERATION_LOADING:
      return {
        ...state,
        loading: true,
        searchLoader: true,
      };
    case types.SR_REPORT_GENERATION_SUCCESS:
      return {
        ...state,
        ReportGeneration: action.payload,
        loading: false,
        searchLoader: false,
      };
    case types.SR_REPORT_GENERATION_FAIL:
      return {
        ...state,
        loading: false,
        searchLoader: false,
        ReportGeneration: [],
      };
    case types.SR_COMMENT_UPDATE_LOADING:
      return {
        ...state,
        loading: true,
      };
    case types.SR_COMMENT_UPDATE_SUCCESS:
      return {
        ...state,
        srCommentUpdate: action.payload,
        loading: false,
      };
    case types.SR_COMMENT_UPDATE_FAIL:
      return {
        ...state,
        loading: false,
        srCommentUpdate: {},
      };
    case types.SR_SEARCH_FILTER_LOADING:
      return {
        ...state,
        loading: true,
        searchLoader: true,
      };
    case types.SR_SEARCH_FILTER_SUCCESS:
      return {
        ...state,
        srSearchData: action.payload,
        loading: false,
        searchLoader: false,
      };
    case types.SR_SEARCH_FILTER_FAIL:
      return {
        ...state,
        loading: false,
        searchLoader: false,
        srSearchData: [],
      };
    case types.SR_SEASON_SEARCH_FILTER_LOADING:
      return {
        ...state,
        loading: true,
        searchLoader: true,
      };
    case types.SR_SEASON_SEARCH_FILTER_SUCCESS:
      return {
        ...state,
        srSeasonSearch: action.payload,
        loading: false,
        searchLoader: false,
      };
    case types.SR_SEASON_SEARCH_FILTER_FAIL:
      return {
        ...state,
        loading: false,
        searchLoader: false,
        srSeasonSearch: [],
      };
    case types.SR_BULK_SAVE_LOADING:
      return {
        ...state,
        loading: true,
        searchLoader: true,
      };
    case types.SR_BULK_SAVE_SUCCESS:
      return {
        ...state,
        srBulkSaveResponse: action.payload,
        loading: false,
        searchLoader: false,
      };
    case types.SR_BULK_SAVE_FAIL:
      return {
        ...state,
        loading: false,
        searchLoader: false,
        srUnsolicitedSamples: [],
      };
    case types.GET_SR_UNSOLICITED_LIST_LOADING:
      return {
        ...state,
        loading: true,
        searchLoader: true,
        srRefreshSpinner: true,
      };
    case types.GET_SR_UNSOLICITED_LIST_SUCCESS:
      return {
        ...state,
        srUnsolicitedList: action.payload,
        loading: false,
        searchLoader: false,
        srRefreshSpinner: false,
      };
    case types.GET_SR_UNSOLICITED_LIST_FAIL:
      return {
        ...state,
        loading: false,
        srUnsolicitedList: [],
        searchLoader: false,
        srRefreshSpinner: false,
      };
    case types.SR_UNSOLICITED_BULK_UPLOAD_LOADING:
      return {
        ...state,
        loading: true,
        searchLoader: true,
      };
    case types.SR_UNSOLICITED_BULK_UPLOAD_SUCCESS:
      return {
        ...state,
        srUnsolicitedBulkUpload: action.payload,
        loading: false,
        searchLoader: false,
      };
    case types.SR_UNSOLICITED_BULK_UPLOAD_FAIL:
      return {
        ...state,
        loading: false,
        searchLoader: false,
        srUnsolicitedBulkUpload: [],
      };
    case types.SR_UNSOLICITED_EXPORT_LOADING:
      return {
        ...state,
        loading: true,
        searchLoader: true,
      };
    case types.SR_UNSOLICITED_EXPORT_SUCCESS:
      return {
        ...state,
        srUnsolicitedExportData: action.payload,
        loading: false,
        searchLoader: false,
      };
    case types.SR_UNSOLICITED_EXPORT_FAIL:
      return {
        ...state,
        loading: false,
        srUnsolicitedExportData: [],
        searchLoader: false,
      };
    case types.SR_UNSOLICITED_EDIT_LOADING:
      return {
        ...state,
        loading: true,
        searchLoader: true,
      };
    case types.SR_UNSOLICITED_EDIT_SUCCESS:
      return {
        ...state,
        srUnsolicitedEdits: action.payload,
        loading: false,
        searchLoader: false,
      };
    case types.SR_UNSOLICITED_EDIT_FAIL:
      return {
        ...state,
        loading: false,
        srUnsolicitedEdits: [],
        searchLoader: false,
      };
    case types.SR_LOGS_LOADING:
      return {
        ...state,
        loading: true,
        srLogsLoading: true,
      };
    case types.SR_LOGS_SUCCESS:
      return {
        ...state,
        srLogsData: action.payload,
        loading: false,
        srLogsLoading: false,
      };
    case types.SR_LOGS_FAIL:
      return {
        ...state,
        loading: false,
        srLogsLoading: false,
        srLogsData: [],
      };
    case types.UNSOLICITED_LIST_LOADING:
      return {
        ...state,
        loading: true,
      };
    case types.UNSOLICITED_LIST_SUCCESS:
      return {
        ...state,
        UnsolicitedList: action.payload,
        loading: false,
      };
    case types.UNSOLICITED_LIST_FAIL:
      return {
        ...state,
        loading: false,
        UnsolicitedList: [],
      };
    case types.SR_DUPLICATE_LOADING:
      return {
        ...state,
        loading: true,
      };
    case types.SR_DUPLICATE_SUCCESS:
      return {
        ...state,
        loading: true,
      };
    case types.SR_DUPLICATE_FAIL:
      return {
        ...state,
        loading: false,
      };
    default:
      return state;
  }
};
